const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const STANDARD = new Set(["PageView", "Lead", "ViewContent", "AddToCart", "InitiateCheckout"]);

const firedPaths = new Set();

export function initPixel() {
  if (!PIXEL_ID) return;
  const w = window;
  if (w.fbq) return;
  const n = (w.fbq = function (...args) {
    n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
  });
  n.queue = [];
  n.loaded = true;
  n.version = "2.0";
  w.fbq("init", PIXEL_ID);
  // Keep the ~280KB fbevents.js + config fetch off the critical path: the
  // stub above queues every event (PageView, ViewContent, AddToCart…) and
  // flushes them the moment the real pixel script arrives after page load.
  const load = () => {
    const s = document.createElement("script");
    s.async = true;
    s.src = "https://connect.facebook.net/en_US/fbevents.js";
    document.head.appendChild(s);
  };
  if (document.readyState === "complete") load();
  else window.addEventListener("load", load, { once: true });
}

function getCookie(name) {
  return document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${name}=`))
    ?.split("=")
    .slice(1)
    .join("=");
}

// Meta best practice: if the _fbc cookie wasn't set (e.g. in-app browsers),
// synthesize it from the fbclid captured in the landing URL.
function getFbc() {
  const cookie = getCookie("_fbc");
  if (cookie) return cookie;
  try {
    const attr = JSON.parse(sessionStorage.getItem("pogo_attr") || "{}");
    if (attr.fbclid)
      return `fb.1.${Math.floor(Date.now() / 1000)}.${attr.fbclid}`;
  } catch (e) {}
  return undefined;
}

export function newEventId() {
  if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
}

export function trackBrowser(name, eventId, data = {}) {
  if (!PIXEL_ID || !window.fbq) return;
  window.fbq(STANDARD.has(name) ? "track" : "trackCustom", name, data, {
    eventID: eventId,
  });
}

export async function trackBoth(name, data = {}, email) {
  const eventId = newEventId();
  trackBrowser(name, eventId, data);
  try {
    await fetch(`${API}/meta/events`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        event_name: name,
        event_id: eventId,
        event_source_url: window.location.href,
        fbp: getCookie("_fbp"),
        fbc: getFbc(),
        email,
        custom_data: data,
      }),
    });
  } catch (e) {}
  return eventId;
}

export function trackPageView(path) {
  const p = path || window.location.pathname;
  if (firedPaths.has(p)) return;
  firedPaths.add(p);
  trackBoth("PageView", { path: p });
}
